/*********************************************************************** 
Documentations = https://github.com/azouaoui-med/pro-sidebar-template
************************************************************************/
import React, {useEffect, useState} from 'react';
import {withTranslation} from 'react-i18next';
import {FaChartLine, FaCog, FaCubes, FaIndustry, FaUser, FaAddressCard, FaUsersCog, FaGripVertical, FaBed, FaCalendarDay, FaCalendarWeek, FaCalendarAlt, FaBusinessTime, FaUmbrellaBeach, FaHome, FaPlane, FaBriefcase} from 'react-icons/fa';
import {Menu, MenuItem, ProSidebar, SidebarContent, SidebarFooter, SidebarHeader, SubMenu} from 'react-pro-sidebar';
import {Link} from 'react-router-dom';
import i18n from '../../i18n';
import ActionButton from '../ActionButton';
import I18nUtils from '../utils/I18nUtils';
import Constants from '../../utils/constants';
import SidebarSearch from '../SidebarSearch';
import { useLocation } from 'react-router-dom';
import StringUtils from '../../utils/StringUtils';

const Sidebar = ({
    t,
    collapsed,
    toggled,
    loggedUser,
    handleToggleSidebar,
    handleCollapsedChange,
    handleLogoutUser,
    authService,
    accountService,
    internalUserService,
    submenu
}) => {
    // const userName = authService.getProfile().sub;
    // const role = authService.getProfile().role;
    const [showMenu, changeShowMenu] = useState(false);
    const [showFuntionsMenu, changeShowFunctionsMenu] = useState(false);
    const [showAgreements, changeShowAgreements] = useState(false);
    const [showLanguages, changeShowLanguages] = useState(false);
    const [activeMenu, setActiveMenu] = useState();
    const location = useLocation();


    useEffect(() => {

        const exactPath = location?.pathname?.replace('/', '');
        if (!StringUtils.isBlank(exactPath) && exactPath !== activeMenu) {
            handleMenuItemClick(exactPath);
        }
    }, [location])


    function changeLanguage(language) {
        if (internalUserService !== null) {
            internalUserService.changeLanguage(language).then(() => {
                sessionStorage.setItem('i18nextLng', language);
                i18n.changeLanguage(language);
            });
        }
    }

    function changeRoleType(sapRoleId) {
        if (internalUserService !== null && authService !== null) {
            internalUserService.changeRoleType(sapRoleId).then((res) => {
                authService.setToken(res.token);
                window.location.href = '/#start';
                window.location.reload();
            });
        }
    }

    function renderOverlay() {
        return (
            <div
                className='show-menu-overlay'
                onClick={(e) => {
                    e.preventDefault();
                    if (showMenu || showFuntionsMenu) {
                        changeShowMenu(false);
                        changeShowFunctionsMenu(false);
                        changeShowLanguages(false);
                        changeShowAgreements(false);
                    }
                }}
            />
        );
    }

    function loader() {
        let label = 'Operacja w toku, proszę czekać.';
        return (
            <div id='cover-spin-container'>
                <div id='cover-spin' />
                <div id='cover-spin-text'>
                    <p>{label}</p>
                </div>
            </div>
        );
    }

    const handleMenuItemClick = (menuName) => {
        const exactPath = location?.pathname?.replace('/', '');
        if (exactPath === menuName) {
            setActiveMenu(menuName);
        }
    };

    const classNameActive = (className) =>{
        return activeMenu === className ? 'active' : ''
    }

    function renderHorizontalSidebar() {
        return !authService.loggedIn() && !submenu ? null : (
            <div style={{width: '100%'}}>
                <div className='sidebar-horizontal-content'>
                    <ActionButton
                        label={t('sidebar.sidebarMenuButton')}
                        variant={showMenu ? 'sidebar-button menu-close' : 'sidebar-button menu'}
                        handleClick={(e) => {
                            e.preventDefault();
                            changeShowMenu(!showMenu);
                            changeShowFunctionsMenu(false);
                            changeShowLanguages(false);
                            changeShowAgreements(false);
                        }}
                        iconSvg={showMenu ? 'ico-sidebar-close' : 'ico_sidebar_menu'}
                        iconSide='left'
                        iconSize={showMenu ? 'menu-close' : 'menu'}
                    />
                    {/* <img className='sidebar-header-logo' alt='logo' src='/images/timehero-logo.png' /> */}
                    <span />
                    <div onClick={()=>handleLogoutUser()} className='pro-sidebar-logout' rel='noopener noreferrer'>
                        <span>{t('header.logout')}</span>
                    </div>

                </div>
                <div className={`sidebar ${showMenu ? 'show-menu' : ''}`}>{renderVerticalSidebar()}</div>
                <div className={`sidebar functions-menu ${showFuntionsMenu ? 'show-menu' : ''}`}>{renderFunctionsSidebar()}</div>
            </div>
        );
    }

    function renderVerticalSidebar() {

        const demoMode = process.env.REACT_APP_DEMO_MODE === "true";

        return !authService.loggedIn() ? null : (
            <React.Fragment>
                <div className={`pro-sidebar-background ${showMenu ? 'show-menu' : ''}`} />
                {renderOverlay()}
                <ProSidebar id='pro-sidebar' collapsed={collapsed} toggled={toggled} onToggle={handleToggleSidebar} className='pro-sidebar-layout'>
                    {submenu ? null : (
                        <SidebarHeader>
                            <div className='sidebar-header-logo-div' />
                        </SidebarHeader>
                    )}
                    {/* <SidebarSearch /> */}
                    <SidebarContent>
                        <Menu>
                            {/* <Menu>
                                <MenuItem className={classNameActive('dashboard')}  onClick={() => handleMenuItemClick('dashboard')} icon={<FaHome />} >
                                    Dashboard
                                    <Link to='/dashboard' />
                                </MenuItem>
                            </Menu> */}
                            <Menu className='visibleOnlySmallScreen'>
                                <MenuItem className={classNameActive('profile')}  onClick={() => handleMenuItemClick('profile')} icon={<FaUser />} >
                                    Profil
                                    <Link to='/profile' id='menu_profile'/>
                                </MenuItem>
                            </Menu>    
                            {authService.isUserInAnyRole("ROLE_REPORT_OWN_DELEGATION") && <Menu>
                                <MenuItem className={classNameActive('my-delegation-list')}  onClick={() => handleMenuItemClick('my-delegation-list')} icon={<FaBriefcase />} >
                                    Moje delegacje
                                    <Link to='/my-delegation-list' />
                                </MenuItem>
                            </Menu>}
                            {authService.getProfile().allowMyTimeInPortal && authService.isUserInRole('ROLE_REPORT_OWN_TIME') ? (
                                <Menu>
                                    <SubMenu title='Mój czas pracy' id='userReportingMenu' icon={<FaBusinessTime />}>
                                        <MenuItem className={classNameActive('day-view')} id='dayViewSubMenu'  onClick={() => handleMenuItemClick('day-view')} icon={<FaCalendarDay />}>
                                            Dzień
                                            <Link to='/day-view' />
                                        </MenuItem>
                                        <MenuItem className={classNameActive('week-view')} id='weekViewSubMenu' onClick={() => handleMenuItemClick('week-view')} icon={<FaCalendarWeek />}>
                                            Tydzień
                                            <Link to='/week-view' />
                                        </MenuItem>
                                        <MenuItem className={classNameActive('month-view')} id='monthViewSubMenu' onClick={() => handleMenuItemClick('month-view')} icon={<FaCalendarAlt />}>
                                            Miesiąc
                                            <Link to='/month-view' />
                                        </MenuItem>
                                    </SubMenu>
                                </Menu>
                            ) : null}

                            {authService.isUserInAnyRole('ROLE_LEAVE_REQUEST_VIEW') ? (
                                <Menu>
                                    <SubMenu title='Wnioski urlopowe' icon={<FaUmbrellaBeach />}>
                                    <MenuItem className={classNameActive('employee-leave-request-view')}  onClick={() => handleMenuItemClick('employee-leave-request-view')}>
                                            {"Moje wnioski urlopowe"}
                                            <Link to='/employee-leave-request-view' />
                                        </MenuItem>
                                    </SubMenu>
                                </Menu>) : null}

                            {authService.isUserInAnyRole('ROLE_PROJECT_LIST_VIEW', 'ROLE_TIMESHEET_LIST_VIEW') ? (
                            <Menu>
                                <SubMenu title='Projekty' id='projects' icon={<FaCubes />}>
                                    {authService.isUserInRole('ROLE_PROJECT_LIST_VIEW') ? (
                                        <MenuItem className={classNameActive('project-list')}  id='projects-list' onClick={() => handleMenuItemClick('project-list')}>
                                            Lista projektów
                                            <Link to='/project-list' />
                                        </MenuItem>
                                    ) : null}                                    
                                    {authService.isUserInRole('ROLE_TIMESHEET_LIST_VIEW') ? (
                                        <MenuItem className={classNameActive('reported-day-list')} id='timesheets'  onClick={() => handleMenuItemClick('reported-day-list')}>
                                            Lista kart pracy
                                            <Link to='/reported-day-list' />
                                        </MenuItem>
                                    ) : null}
                                </SubMenu>
                            </Menu>) : null}
                            {authService.isUserInAnyRole('ROLE_PROJECT_LEADER_PLANING_VIEW', 'ROLE_PROJECT_DASHBOARD_VIEW', 'ROLE_USER_RESERVE_VIEW') ? (
                                <Menu>
                                    <SubMenu title='Planowanie' icon={<FaCubes />}>
                                        {authService.isUserInRole('ROLE_PROJECT_DASHBOARD_VIEW') ? (
                                        <MenuItem className={classNameActive('project-dashboard')}  onClick={() => handleMenuItemClick('project-dashboard')}>
                                            Tablica
                                            <Link to='/project-dashboard' />
                                        </MenuItem>) : null }
                                        {authService.isUserInRole('ROLE_PROJECT_LEADER_PLANING_VIEW') && authService.getProfile().hideLeadersAndManagers !== true  ? (
                                            <MenuItem className={classNameActive('managers')}  onClick={() => handleMenuItemClick('managers')}>
                                                Planing
                                                <Link to='/project/plan/managers' />
                                            </MenuItem>
                                        ) : null}
                                        {authService.isUserInRole('ROLE_USER_RESERVE_VIEW') ? (
                                            <MenuItem className={classNameActive('reserve')}  onClick={() => handleMenuItemClick('reserve')} /*icon={<FaAddressCard />}*/>
                                                Rezerwa
                                                <Link to='/reserve' />
                                            </MenuItem>
                                        ) : null}
                                    </SubMenu>
                                </Menu>
                            ) : null}
                            {authService.isUserInAnyRole('ROLE_ACCOMMODATION_LIST_VIEW', 'ROLE_ACCOMMODATION_PLANING_VIEW', 'ROLE_ACCOMMODATION_DASHBOARD_VIEW') ? (
                            <Menu>
                                <SubMenu title='Noclegi' icon={<FaBed />}>
                                    {authService.isUserInRole('ROLE_ACCOMMODATION_LIST_VIEW') ? (
                                    <MenuItem className={classNameActive('accommodation-list')}  onClick={() => handleMenuItemClick('accommodation-list')}>
                                        Lista
                                        <Link to='/accommodation-list' />
                                    </MenuItem>
                                    ) : null}
                                    {authService.isUserInRole('ROLE_ACCOMMODATION_PLANING_VIEW') ? (
                                    <MenuItem className={classNameActive('accommodation-timeline')}  onClick={() => handleMenuItemClick('accommodation-timeline')}>
                                        Plan dla miejsca
                                        <Link to='/accommodation-timeline' />
                                    </MenuItem>
                                    ) : null}
                                    {authService.isUserInRole('ROLE_ACCOMMODATION_PLANING_VIEW') ? (
                                    <MenuItem className={classNameActive('accommodation-employee-timeline')}  onClick={() => handleMenuItemClick('accommodation-employee-timeline')}>
                                        Plan dla pracownika
                                        <Link to='/accommodation-employee-timeline' />
                                    </MenuItem>
                                    ) : null}
                                    {authService.isUserInRole('ROLE_ACCOMMODATION_CATEGORY_LIST_VIEW') ? (
                                    <MenuItem className={classNameActive('accommodation-category')}  onClick={() => handleMenuItemClick('accommodation-category')}>
                                        Kategorie noclegu
                                        <Link to='/accommodation-category'/>
                                    </MenuItem>
                                    ) : null}
                                    {authService.isUserInRole('ROLE_ACCOMMODATION_DASHBOARD_VIEW') ? (
                                    <MenuItem className={classNameActive('accommodation-dashboard')}  onClick={() => handleMenuItemClick('accommodation-dashboard')}>
                                         Tablica
                                        <Link to='/accommodation-dashboard'/>
                                    </MenuItem>
                                    ) : null}
                                </SubMenu>
                                </Menu>
                            ) : null}
                            {authService.isUserInAnyRole('ROLE_CLIENT_LIST_VIEW', 'ROLE_PROJECT_EXTERNAL_SUPERVISOR_LIST_VIEW', 'ROLE_SUBCONTRACTOR_LIST_VIEW') ? (
                            <Menu>
                                <SubMenu title='Kontrahenci' icon={<FaIndustry />}>
                                    {authService.isUserInRole('ROLE_CLIENT_LIST_VIEW') ? (
                                        <MenuItem className={classNameActive('client-list')}  onClick={() => handleMenuItemClick('client-list')}>
                                            Klienci
                                            <Link to='/client-list' />
                                        </MenuItem>
                                    ) : null}
                                    {authService.isUserInRole('ROLE_PROJECT_EXTERNAL_SUPERVISOR_LIST_VIEW') ? (
                                    <MenuItem className={classNameActive('external-supervisor')}  onClick={() => handleMenuItemClick('external-supervisor')}>
                                        {t('externalSupervisor.menu')}
                                        <Link to='/external-supervisor/list' />
                                    </MenuItem>
                                    ) : null }
                                    {authService.isUserInRole('ROLE_SUBCONTRACTOR_LIST_VIEW') ? (
                                    <MenuItem className={classNameActive('subcontractor-list')}  onClick={() => handleMenuItemClick('subcontractor-list')}>
                                        {t('subcontractor.menu')}
                                        <Link to='/subcontractor-list' />
                                    </MenuItem>
                                    ) : null}
                                </SubMenu>
                            </Menu>
                            ) : null}
                            {authService.isUserInAnyRole('ROLE_REPORT_USER_TIME', 'ROLE_REPORT_PAYROLL_ENTRY' ,'ROLE_REPORT_DRIVE_AFTER_HOUR', 'ROLE_REPORT_PROJECTS_CUMULATIVE', 'ROLE_REPORT_PROJECTS_SETTLE', 'ROLE_REPORT_PAYOUT') ? (
                            <Menu>
                                <SubMenu title='Raporty' id={'reports'} icon={<FaChartLine />}>
                                {authService.isUserInRole('ROLE_REPORT_USER_TIME') ? (
                                        <MenuItem id={'hourlyReport'} className={classNameActive('hourlyreport-list')}  onClick={() => handleMenuItemClick('hourlyreport-list')} >
                                            Raport godzinowy
                                            <Link to='/hourlyreport-list'  />
                                        </MenuItem>
                                    ) : null} 
                                    {authService.isUserInAnyRole('ROLE_ADMIN', 'ROLE_USER', 'ROLE_SUPERVISOR', 'ROLE_CTO') ? (
                                        <MenuItem>
                                            Obciążenie projektów
                                            <Link to='/project-daily-overview' />
                                        </MenuItem>
                                    ) : null}
                                    {authService.isUserInRole('ROLE_REPORT_PAYROLL_ENTRY') ? (
                                        <MenuItem id={'payroll-entry'} className={classNameActive('payroll-entry-list')}  onClick={() => handleMenuItemClick('payroll-entry-list')} >
                                            Wsad do listy płac
                                            <Link to='/payroll-entry-list'  />
                                        </MenuItem>
                                    ) : null}
                                    {authService.isUserInRole('ROLE_REPORT_DRIVE_AFTER_HOUR') ? (
                                        <MenuItem className={classNameActive('after-hours-drive-alarm-list')}  onClick={() => handleMenuItemClick('after-hours-drive-alarm-list')}>
                                            Przejazdy po godzinach pracy
                                            <Link to='/after-hours-drive-alarm-list' />
                                        </MenuItem>
                                    ) : null}
                                    {authService.isUserInRole('ROLE_REPORT_PROJECTS_CUMULATIVE') ? (
                                        <MenuItem className={classNameActive('project-report-cumulative')}  onClick={() => handleMenuItemClick('project-report-cumulative')}>
                                            Projekty narastająco
                                            <Link to='/project-report-cumulative' />
                                        </MenuItem>
                                    ) : null}
                                    {authService.isUserInRole('ROLE_REPORT_PROJECTS_SETTLE') ? (
                                        <MenuItem className={classNameActive('project-report-settle')}  onClick={() => handleMenuItemClick('project-report-settle')}>
                                            Projekty rozliczenie
                                            <Link to='/project-report-settle' />
                                        </MenuItem>
                                    ) : null}
                                    {(authService.isUserInRole('ROLE_REPORT_PAYOUT') && authService.getProfile().userContractPriceStrategy !== Constants.NONE) ?
                                         (
                                        <MenuItem className={classNameActive('pay-report')}  onClick={() => handleMenuItemClick('pay-report')}>
                                            Wypłaty
                                            <Link to='/pay-report' />
                                        </MenuItem>
                                    ) : null}
                                </SubMenu>
                            </Menu>
                            ) : null}
                            {authService.isUserInAnyRole('ROLE_USER_LIST_VIEW', 'ROLE_USER_CATEGORY_LIST_VIEW', 'ROLE_USER_DOCUMENT_TYPE_LIST_VIEW', 'ROLE_USER_ABSENCE_REASON_LIST_VIEW', 'ROLE_USER_RATE_LIST_VIEW') ? (
                                <Menu>
                                    <SubMenu id={'users-menu'} title='Zarządzanie pracownikami' icon={<FaUsersCog />}>
                                        {authService.getProfile().usersViewMode === 'SEPARATE' ? (
                                            <>
                                                {authService.isUserInRole('ROLE_USER_LIST_VIEW') ? (
                                                    <MenuItem className={classNameActive('employee-list')}  onClick={() => handleMenuItemClick('employee-list')}>
                                                        Pracownicy
                                                        <Link to='/employee-list' />
                                                    </MenuItem>
                                                ) : null}
                                                {authService.isUserInRole('ROLE_USER_LIST_VIEW') && !authService.isUserInRole('ROLE_USER_TYPE_EXTERNAL_MANAGER') ? (
                                                    <MenuItem className={classNameActive('user-list')}  onClick={() => handleMenuItemClick('user-list')}>
                                                        Użytkownicy wewnętrzni
                                                        <Link to='/user-list' />
                                                    </MenuItem>
                                                ) : null}
                                            </>
                                        ) : null}
                                        {authService.getProfile().usersViewMode === 'ALL' ?
                                            <>
                                                {authService.isUserInRole('ROLE_USER_LIST_VIEW') ? (
                                                    <MenuItem id={'all-users-list'} className={classNameActive('user-list')}  onClick={() => handleMenuItemClick('user-list')}>
                                                        Użytkownicy
                                                        <Link to='/user-list' />
                                                    </MenuItem>
                                                ) : null}
                                            </>
                                            :
                                            null
                                        }
                                          {authService.isUserInRole('ROLE_DELEGATION_LIST_VIEW') ? (
                                            <MenuItem className={classNameActive('delegation-list')}  onClick={() => handleMenuItemClick('delegation-list')}>
                                            {t('delegation.menu')}
                                            <Link to='/delegation-list' />
                                            </MenuItem>
                                         ) : null}
                                         {authService.isUserInRole('ROLE_LEAVE_REQUEST_MANAGE_LIST') ? (
                                            <MenuItem className={classNameActive('employee-leave-request-list')}  onClick={() => handleMenuItemClick('employee-leave-request-list')}>
                                            {t('leaveRequest.menu')}
                                            <Link to='/employee-leave-request-list' />
                                            </MenuItem>
                                         ) : null}
                                        {authService.isUserInRole('ROLE_USER_CATEGORY_LIST_VIEW') ? (
                                        <MenuItem className={classNameActive('employeecategory-list')}  onClick={() => handleMenuItemClick('employeecategory-list')}>
                                            {t('employeeCategory.menu')}
                                            <Link to='/employeecategory-list' />
                                        </MenuItem >
                                        ) : null}
                                        {authService.isUserInRole('ROLE_USER_DOCUMENT_TYPE_LIST_VIEW') ? (
                                        <MenuItem  className={classNameActive('document-types-list')}  onClick={() => handleMenuItemClick('document-types-list')}>
                                            {t('documentType.menu')}
                                            <Link to='/document-types-list' />
                                        </MenuItem>
                                        ) : null}
                                        {authService.isUserInRole('ROLE_USER_ABSENCE_REASON_LIST_VIEW') ? (
                                        <MenuItem className={classNameActive('employee-absence-reason-list')}  onClick={() => handleMenuItemClick('employee-absence-reason-list')}>
                                            {t('employee.absence.menu')}
                                            <Link to='/employee-absence-reason-list' />
                                        </MenuItem>
                                        ) : null}
                                        {authService.isUserInRole('ROLE_USER_RATE_LIST_VIEW') ? (
                                        <MenuItem className={classNameActive('driver-rate-list')}  onClick={() => handleMenuItemClick('driver-rate-list')}>
                                            {t('driver-rate.menu')}
                                            <Link to='/driver-rate-list' />
                                        </MenuItem>
                                        ) : null}
                                    </SubMenu>
                                </Menu>
                            ) : null}

                            {authService.isUserInAnyRole('ROLE_PROJECT_CATEGORY_LIST_VIEW', 'ROLE_PROJECT_ACTIVITY_LIST_VIEW', 'ROLE_CAR_LIST_VIEW', 'ROLE_TOOL_LIST_VIEW', 'ROLE_TOOLBOX_LIST_VIEW') ? (
                                <Menu>
                                    <SubMenu title='Komponenty projektu' icon={<FaGripVertical />}>
                                        {authService.isUserInRole('ROLE_PROJECT_CATEGORY_LIST_VIEW') ? (
                                        <MenuItem className={classNameActive('projectcategory-list')}  onClick={() => handleMenuItemClick('projectcategory-list')}>
                                            {t('projectCategory.menu')}
                                            <Link to='/projectcategory-list' />
                                        </MenuItem>
                                        ) : null}
                                        {authService.isUserInRole('ROLE_PROJECT_ACTIVITY_LIST_VIEW') ? (
                                        <MenuItem className={classNameActive('activity-list')}  onClick={() => handleMenuItemClick('activity-list')}>
                                            {t('activity.menu')}
                                            <Link to='/activity-list' />
                                        </MenuItem>
                                        ) : null}
                                        {authService.isUserInRole('ROLE_CAR_LIST_VIEW') ? (
                                        <MenuItem className={classNameActive('car-list')}  onClick={() => handleMenuItemClick('car-list')}>
                                            {t('car.menu')}
                                            <Link to='/car-list' />
                                        </MenuItem>
                                        ) : null}
                                        {authService.isUserInRole('ROLE_TOOL_LIST_VIEW') ? (
                                        <MenuItem className={classNameActive('tool-list')}  onClick={() => handleMenuItemClick('tool-list')}>
                                            Narzędzia
                                            <Link to='/tool-list' />
                                        </MenuItem>
                                        ) : null}
                                        {authService.isUserInRole('ROLE_TOOLBOX_LIST_VIEW') ? (
                                        <MenuItem className={classNameActive('tools-list')}  onClick={() => handleMenuItemClick('tools-list')}>
                                            Zestawy Narzędzi
                                            <Link to='/tools-list' />
                                        </MenuItem>
                                        ) : null}
                                    </SubMenu>
                                </Menu>
                            ) : null}

                            {authService.isUserInAnyRole('ROLE_PARAM_LIST_VIEW', 'ROLE_DICT_EMAIL_TEMPLATE_LIST_VIEW', 'ROLE_DICT_COUNTRY_LIST_VIEW', 'ROLE_EVENT_LOG_LIST_VIEW','ROLE_PUBLIC_HOLIDAYS_VIEW') ? (
                                <Menu>
                                    <SubMenu title='Administracja' icon={<FaCog />}>
                                        {authService.isUserInRole('ROLE_DICT_COUNTRY_LIST_VIEW') ? (
                                        <MenuItem className={classNameActive('country-list')}  onClick={() => handleMenuItemClick('country-list')}>
                                            Kraje
                                            <Link to='/country-list' />
                                        </MenuItem>
                                        ) : null}
                                        {authService.isUserInRole('ROLE_PUBLIC_HOLIDAYS_VIEW') ? (
                                        <MenuItem className={classNameActive('public-holidays-calendar')}  onClick={() => handleMenuItemClick('public-holidays-calendar')}>
                                            Kalendarz dni wolnych
                                            <Link to='/public-holidays-calendar' />
                                        </MenuItem>
                                        ) : null}
                                        {authService.isUserInRole('ROLE_DICT_EMAIL_TEMPLATE_LIST_VIEW') ? (
                                            <MenuItem className={classNameActive('email-list')}  onClick={() => handleMenuItemClick('email-list')}>
                                                {t('email.menu')}
                                                <Link to='/email-list' />
                                            </MenuItem>
                                        ) : null}
                                        {authService.isUserInRole('ROLE_PARAM_LIST_VIEW') && !demoMode ? (
                                            <MenuItem className={classNameActive('settings-list')}  onClick={() => handleMenuItemClick('settings-list')}>
                                                Parametry aplikacji
                                                <Link to='/settings-list' />
                                            </MenuItem>
                                        ) : null}
                                        {authService.isUserInRole('ROLE_EVENT_LOG_LIST_VIEW') ? (
                                        <MenuItem className={classNameActive('eventlog-list')}  onClick={() => handleMenuItemClick('eventlog-list')}>
                                            {t('logEntry.list.menu')}
                                            <Link to='/eventlog-list' />
                                        </MenuItem>
                                        ) : null}
                                    </SubMenu>
                                </Menu>
                            ) : null}
                        </Menu>
                        <SidebarFooter>
                            <span className='sidebar-version p-2'>
                                wersja: {process.env.REACT_APP_VERSION} ({process.env.REACT_APP_BUILD_NUMBER})
                            </span>
                        </SidebarFooter>
                    </SidebarContent>
                </ProSidebar>
            </React.Fragment>
        );
    }

    function renderFunctionsSidebar() {
        const supportedLanguages = I18nUtils.getSupportedLanguages(3);
        const languages = [];
        supportedLanguages.forEach((l) => {
            languages.push({value: l, label: t(`header.${l}`)});
        });
        return !authService.loggedIn() ? null : (
            <React.Fragment>
                {renderOverlay()}
                <ProSidebar
                    collapsed={collapsed}
                    toggled={toggled}
                    onToggle={handleToggleSidebar}
                    className='pro-sidebar-layout functions-menu'
                >
                    <SidebarContent>
                        <Menu>
                            {authService.getProfile().sapRoleIdsList?.length > 1 ? (
                                <MenuItem key='agreement' className='sidebar-submenu'>
                                    <div
                                        onClick={(e) => {
                                            e.preventDefault();
                                            changeShowAgreements(!showAgreements);
                                            changeShowLanguages(false);
                                        }}
                                    >
                                        {t('header.agreement')}
                                    </div>
                                    <Menu key='agreement-items' className={`sidebar-submenu-items ${showAgreements ? 'show' : ''}`}>
                                        {authService.getProfile().sapRoleIdsList.map((el) => {
                                            return (
                                                <MenuItem key={`agreement-${el}`} className='agreement-item'>
                                                    <div
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            changeShowAgreements(false);
                                                            changeShowFunctionsMenu(false);
                                                            if (el !== authService.getProfile().agreementSapRoleId) {
                                                                changeRoleType(el);
                                                            }
                                                        }}
                                                    >
                                                        {t(`header.${el}`)}
                                                    </div>
                                                </MenuItem>
                                            );
                                        })}
                                    </Menu>
                                </MenuItem>
                            ) : null}
                            {languages.length > 1 ? (
                                <MenuItem key='language' className='sidebar-submenu'>
                                    <div
                                        onClick={(e) => {
                                            e.preventDefault();
                                            changeShowLanguages(!showLanguages);
                                            changeShowAgreements(false);
                                        }}
                                    >
                                        {t('header.language')}
                                    </div>
                                    <Menu key='language-items' className={`sidebar-submenu-items ${showLanguages ? 'show' : ''}`}>
                                        {languages.map((el) => {
                                            return (
                                                <MenuItem key={`language-${el}`} className='language-item'>
                                                    <div
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            changeShowLanguages(false);
                                                            changeShowFunctionsMenu(false);
                                                            if (el.value !== sessionStorage.getItem('i18nextLng')) {
                                                                changeLanguage(el.value);
                                                            }
                                                        }}
                                                    >
                                                        {el.label}
                                                    </div>
                                                </MenuItem>
                                            );
                                        })}
                                    </Menu>
                                </MenuItem>
                            ) : null}
                        </Menu>
                    </SidebarContent>
                    <SidebarFooter>
                        <span className='sidebar-version'>
                            wersja: {process.env.REACT_APP_VERSION} ({process.env.REACT_APP_BUILD_NUMBER})
                        </span>
                    </SidebarFooter>
                </ProSidebar>
            </React.Fragment>
        );
    }

    function render() {
        return submenu ? renderHorizontalSidebar() : renderVerticalSidebar();
    }
    return render();
};

export default withTranslation()(Sidebar);
